import { render, staticRenderFns } from "./Withdrawkbank.vue?vue&type=template&id=4b99f83b"
import script from "./Withdrawkbank.vue?vue&type=script&lang=js"
export * from "./Withdrawkbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports